/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_History_NoneInputs */



/**
* | output |
* | --- |
* | "Not practised yet" |
*
* @param {Practice_History_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_history_none = /** @type {((inputs?: Practice_History_NoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_History_NoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog niet geoefend")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore travaillé")
	return /** @type {LocalizedString} */ ("Not practised yet")
});